// TODO: Move to shareable components library (bek-components) when the library is ready
import {Component, Prop, Watch, Vue} from 'vue-property-decorator';

@Component({
    name: "p-input",
    model: {
        prop: 'modelValue',
        event: 'change'
    }
})
export default class PrettyInput extends Vue {
    @Prop({type: String, required: false})
    private type!: string;
    @Prop({type: String, required: false})
    private name!: string;
    @Prop({type: String, required: false})
    private id!: string;
    @Prop({type: String, required: false})
    private value!: string;
    @Prop({required: false})
    private modelValue!: any;
    @Prop({required: false})
    private trueValue!: any;
    @Prop({required: false})
    private falseValue!: any;
    @Prop({type: Boolean, required: false})
    private checked!: boolean;
    @Prop({required: false})
    private disabled!: any;
    @Prop({required: false})
    private required!: any;
    @Prop({required: false})
    private indeterminate!: any;
    @Prop({type: String, required: false, default: 'danger'})
    private color!: string;
    @Prop({type: String, required: false})
    private offColor!: string;
    @Prop({type: String, required: false})
    private hoverColor!: string;
    @Prop({type: String, required: false})
    private indeterminateColor!: string;
    @Prop({required: false})
    private toggle!: any;
    @Prop({required: false})
    private hover!: any;
    @Prop({required: false})
    private focus!: any;

    m_checked: boolean|undefined = undefined;
    default_mode = false;

    get _type() {
        if (this.type) { 
            return this.type;
        }

        return 'checkbox';
    }

    get shouldBeChecked() {
        if (this.modelValue !== undefined) {
            // radio
            if (this._type === 'radio') {
                return this.modelValue === this.value;
            }

            // checkbox
            if (this.modelValue instanceof Array) {
                return this.modelValue.includes(this.value);
            }
            if (this._trueValue) {
                return this.modelValue === this.trueValue;
            }
            return typeof this.modelValue === 'string' ? true : !!this.modelValue;
        }

        if (this.m_checked === undefined)
            return this.m_checked = typeof this.checked === 'string' ? true : !!this.checked;
        else
            return this.m_checked;
    }

    get _disabled() {
        return typeof this.disabled === 'string' ? true : !!this.disabled;
    }

    get _required() {
        return typeof this.required === 'string' ? true : !!this.required;
    }
    get _indeterminate() {
        return typeof this.indeterminate === 'string' ? true : !!this.indeterminate;
    }
    get _trueValue() {
        return typeof this.trueValue === 'string' ? this.trueValue : !!this.trueValue;
    }
    get _falseValue() {
        return typeof this.falseValue === 'string' ? this.falseValue : !!this.falseValue;
    }
    get _toggle() {
        return typeof this.toggle === 'string' ? true : !!this.toggle;
    }
    get _hover() {
        return typeof this.hover === 'string' ? true : !!this.hover;
    }
    get _focus() {
        return typeof this.focus === 'string' ? true : !!this.focus;
    }
    get classes() {
        return {
            pretty: true,
            'p-default': this.default_mode,
            'p-round': this._type === 'radio' ? this.default_mode : false,
            'p-toggle': this._toggle,
            'p-has-hover': this._hover,
            'p-has-focus': this._focus,
            'p-has-indeterminate': this._indeterminate,
        };
    }
    get onClasses() {
        let classes = {
            state: true,
            'p-on': this._toggle
        };
        if (this.color) {
            return {...classes, [`p-${this.color}`]: true};
        }

        return classes;
    }
    get offClasses() {
        let classes = {
            state: true,
            'p-off': true,
        };
        if (this.offColor) {
            return {...classes, [`p-${this.offColor}`]: true};
        }

        return classes;
    }
    get hoverClasses() {
        let classes = {
            state: true,
            'p-is-hover': true,
        };
        if (this.hoverColor) {
            return {...classes, [`p-${this.hoverColor}`]: true};
        }

        return classes;
    }
    get indeterminateClasses() {
        let classes = {
            state: true,
            'p-is-indeterminate': true,
        };
        if (this.indeterminateColor) {
            return {...classes, [`p-${this.indeterminateColor}`]: true};
        }

        return classes;
    }
            
    @Watch('checked')
    updateChecked(v: boolean | undefined) {
        this.m_checked = v;
    }

    @Watch('indeterminate')
    updateIndeterminate (v: any) {
        (this.$refs.input as HTMLFormElement).indeterminate = v;
    }

    mounted() {
        if (this.$vnode.data && !this.$vnode.data.staticClass)
            this.default_mode = true;
        if (this._indeterminate)
        (this.$refs.input as HTMLFormElement).indeterminate = true;
        this.$el.setAttribute(`p-${this._type}`, '');
    }
    updateInput(event: { target: { checked: any; }; }) {
        if (this._type === 'radio') {
            this.$emit('change', this.value);
            return;
        }

        this.$emit('update:indeterminate', false);

        let isChecked = event.target.checked;

        this.m_checked = isChecked;

        if (this.modelValue instanceof Array) {
            let newValue = [...this.modelValue];

            if (isChecked) {
                newValue.push(this.value);
            } else {
                newValue.splice(newValue.indexOf(this.value), 1);
            }

            this.$emit('change', newValue);
        } else {
            this.$emit('change', isChecked ? (this._trueValue ? this.trueValue : true) : (this._falseValue ? this.falseValue : false));
        }
    }
}